import React, { Component } from 'react'
import { Form } from 'redux-form'
import OperatorField from '../components/OperatorField'
import cn from 'classnames'
import Button from 'components/Button'
import sLay from 'styles/modules/layout.scss'
import sText from 'components/Text/Text.scss'

export default class CallerNumberIsForm extends Component {
  render() {
    const { handleSubmit, className, onSubmit, node, nodeInfo, formData, change } = this.props
    const submit = data => onSubmit(node, { extras: data })

    return (
      <Form onSubmit={handleSubmit(submit)} className={className}>
        <div style={{ paddingBottom: '15px' }} className={sText.descrip3}>
          The number must match exactly. You can use this to create special experiences for VIP or
          known callers.{' '}
          <a href={nodeInfo.helpUrl} target="_blank" rel="noopener noreferrer">
            {' '}
            Learn more.
          </a>
        </div>
        <OperatorField
          change={change}
          formData={formData}
          operators={['lessThan', 'greaterThan', 'between', 'is', 'anyOf']}
          type="text"
        />
        <div className={sLay.flex} />
        <div className={cn(sLay['layout-column'])}>
          <Button type="submit" color="tertiary" rect>
            Save Node
          </Button>
        </div>
      </Form>
    )
  }
}



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/CallerNumberIs/CallerNumberIsForm.jsx